var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.hasAttachments
    ? _c(
        "button",
        {
          staticClass: "btn btn-sm btn-primary",
          on: { click: _vm.openAttachments }
        },
        [
          _vm._v(
            "\n  " + _vm._s(_vm.$t("survey.code.openAttachments")) + "\n  "
          ),
          _c("i", { staticClass: "fas fa-external-link-square" })
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }